import { ImgHandler } from "./types/imgHandler.types";

export const imgHandler: ImgHandler = {
    "PUGLIASALUTE" :{
        style_top: "h-24 w-20",
        style_btn: "",
        style_logo_right_corner: "",
        src_login_top: "PUGLIASALUTE_top",
        src_login_btm: "PUGLIASALUTE_bottom",
        src_logo_right_corner: "",
    },
    "SISOS": {
        style_top: "h-24 w-30 mr-8",
        style_btn: "h-6 w-30 mr-8",
        style_logo_right_corner: "h-6 w-30 mr-8 opacity-50",
        src_login_top: "SISOS_top",
        src_login_btm: "promedital-logo-full",
        src_logo_right_corner: "promedital-logo-full",
    },
}